import apiRequestCommon from './index'

export default {
  path: '/v1/getMySsList',

  // マイSS一覧取得API
  async post (appVersionHeader, tsid, otoken) {
    await window.callNativeHTTPX()
    const headers = {
      'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
      'HTTP-X-DAPP-USERID': window.DAPP_USERID,
      'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD,
      'X-CLS-App-Version': appVersionHeader
    }
    const body = {
      tsid,
      otoken
    }
    return apiRequestCommon.post(this.path, body, {
      headers
    })
  }
}
